export const WEB_MODULES_TOKEN = 'web_modules_token'
export const OLD_TOKEN = 'chat_token'
